import { ItemInstance } from '@headless-tree/core';
import { FileItemType } from '../../types';

type HandleRenameItemParamsType = {
  fileId: string;
  newName: string;
};

type HandleRenameItemReturnType<T> = (
  item: ItemInstance<T>,
  value: string
) => void;

export const handleRename = <T extends FileItemType>(
  onRenameItem: (params: HandleRenameItemParamsType) => void
): HandleRenameItemReturnType<T> => {
  return (item: ItemInstance<T>, value: string): void => {
    onRenameItem({ fileId: item.getId(), newName: value });
  };
};
